<template>
    <div class="vhomeBox"  id="vhomeBox">
        <!--    左侧-->


        <div class="contentLeft">
            <reportList  ref="rptlist" @loadRptList="loadRptList"  :rptlist="rptList"  @handleNodeClick="selectedReport" ></reportList>
            <reportdialog  ref="mydialog"   ></reportdialog>
        </div>
        <div class="contentRight contetnShadow " >
            <spread-view ref="spread_view"  > </spread-view>
        </div>



    </div>


</template>

<script>
    // import * as API from "./api"


    import * as jUtil from '@/utils/gcExcelJs.js';
    import $ from 'jquery';
    import reportList from "./reportList"; // 左侧-模块
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    import spreadView from "../res/spread"; // spread

    export default {
        name: "reportView",
        components: {
            eDialog,
            reportList,
            reportdialog,
            spreadView,
            // spreads,
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        data() {
            return {

                rptJson:{},
                rptList:[],
                rptParm:{fid:"",file_json:"",file_type:"rpt",filename:""},

            };
        },



        activated(){
            this.onResize();
        },

        mounted() {
            this.onResize();

        },
        beforeDestroy(){
            // window.removeEventListener("resize",this.onResize);
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $('.contentRight').width(n.w  - $('.contentLeft').width() - 5 );
                $('.contentRight').height(n.h  - 2 );
                this.$refs.spread_view.onResize();
            },
            selectedReport(item){
                this.rptParm= {
                    fid:item.path,
                    filename:item.label,
                    importid:-1,
                    editState :-1,
                    level:0,
                };
                this.$refs.spread_view.addTab(this.rptParm);
            },


            async  loadRptList() {

                let _this=this;
                let res = await jUtil.loadReportList(this.rptParm);
                if (res.code==1) {

                    _this.rptList=res.data;
                    this.$refs.rptlist.setRptList(this.rptList);
                }
                else {
                    this.$refs.mydialog.showDialog({type:"error",text:this.$t('report_report_retrieval_failed')+"!("+res.message+")",info:res.error});
                }
            },

            btn(id){
                if(id==undefined) return;
                let id_clicked=id.split("-");
                let sid=id_clicked[1];
                switch (id_clicked[0]) {


                    case 'collect':
                        $('#collect').hide();
                        $('#expend').show();
                        $('.contentLeft').hide();
                        $('.contentLeft').width(0);
                        this.onResize();
                        break;
                    case 'expend':
                        $('#expend').hide();
                        $('#collect').show();
                        $('.contentLeft').show();
                        $('.contentLeft').width(260);
                        this.onResize();

                        break;
                    default: break;
                }

            },
        },
    }
</script>


<style lang="scss" >

    .vhomeBox {
        margin-top: 0px;
        height: calc(100% - 1px);
        width: 100%;


        .contentLeft {
            float: left;
            width: 260px;
            height: calc(100% - 1px);
            border-bottom: 1px solid #d5d7da;
            border-right: 1px solid #d5d7da;
            z-index: 100;

        }

        .contentRight {
            float: left;
            height: calc(100% - 1px);
            border-bottom: 1px solid #d5d7da;
            z-index: 1000;
        }
    }

    .ul_list {
        height:40px;
        .li {
            margin-top:10px ;
            height: 20px;
            float: left;
            display: block;
        }
    }
</style>

